import axios from 'axios';
import React, { useState, useEffect, useReducer } from 'react';
import styled from 'styled-components'

import { Flex, Text, Spinner } from "../../../../components";
import { Modal, ModalContainer, ModalButton, Input, Select, Label, Toggle } from "../../components";
import Type from "./Type";
import Media from "react-media";
import { NotificationContainer, NotificationManager } from 'react-notifications';

const Header = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 15px 30px;
`;

const Search = styled.input`
  background: transparent;
  flex-grow: 1;
  margin-right: 20px;
  height: 100%;
  color: #fff;
  
  &::placeholder {
    color: #7178B2
  }
`;

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg}
`;

const Content = styled(Flex)`
  padding: 30px;
`;

const HeaderRow = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 18px 24px;
  margin-bottom: 24px;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
`;

const Types = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [licenseTypes, setLicenseTypes] = useState(false);
  const [showModal, setModal] = useState(false);
  const [showEditModal, setEditModal] = useState(false);
  const [discordRoles, setDiscordRoles] = useState(false);

  const [typePayload, setTypePayload] = useState({
    name: "",
    label: "",
    discordRoleID: "",
    oneTimeFee: null,
    recurringFee: null,
    trialDays: 0,
    unbindable: 1,
    unbindDelay: 0,
    maxInstances: 0
  });

  const [editTypePayload, setEditTypePayload] = useState({
    typeID: null,
    name: "",
    label: "",
    discordRoleID: "",
    oneTimeFee: null,
    recurringFee: null,
    trialDays: 0,
    unbindable: 1,
    unbindDelay: 0,
    maxInstances: 0,
    renewalLength: 0
  });

  useEffect(() => {
    axios
      .get('/api/admin/licenses/types')
      .then(res => {
        setLicenseTypes(res.data.licenseTypes);
        setDiscordRoles(res.data.discordRoles);
        setTypePayload({
          ...typePayload,
          discordRoleID: res.data.discordRoles.length > 0 ? res.data.discordRoles[0].id : ""
        })
        setEditTypePayload({
          ...typePayload,
          discordRoleID: res.data.discordRoles.length > 0 ? res.data.discordRoles[0].id : ""
        })
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  const revealModal = () => {
    setModal(true)
  };

  const revealEditModal = (typeData) => {
    setEditModal(true)
    setEditTypePayload({
      typeID: typeData.id,
      name: typeData.name,
      label: typeData.label,
      discordRoleID: typeData.discord_role_id,
      oneTimeFee: typeData.one_time_fee,
      recurringFee: typeData.recurring_fee,
      trialDays: typeData.trial_amount,
      unbindable: typeData.unbindable,
      unbindDelay: typeData.unbind_delay,
      maxInstances: typeData.max_instances,
      renewalLength: typeData.renewal_length
    })
  };

  const hideModal = () => setModal(false);

  const hideEditModal = () => setEditModal(false);

  const renderDiscordRoles = (isEdit = false) => {

    if (isEdit) {
      return (
        <Select
          value={editTypePayload.discordRoleID}
          onChange={(e) => {
            setEditTypePayload({
              ...editTypePayload,
              discordRoleID: e.target.value
            })
          }}
        >
          {discordRoles.map((value) => {
            return <option value={value.id}>{value.name}</option>
          })}
        </Select>
      )
    } else {
      return (
        <Select
          onChange={(e) => {
            setTypePayload({
              ...typePayload,
              discordRoleID: e.target.value
            })
          }}
        >
          {discordRoles.map((value) => {
            return <option value={value.id}>{value.name}</option>
          })}
        </Select>
      )
    }

  }

  const renderOneTimeFee = (isEdit = false) => {

    if (isEdit) {
      return (
        <Input
          type="number"
          value={editTypePayload.oneTimeFee}
          placeholder="0"
          onChange={(e) => {
            setEditTypePayload({
              ...editTypePayload,
              oneTimeFee: e.target.value
            })
          }}
        />
      )
    } else {
      return (
        <Input
          type="number"
          placeholder="0"
          onChange={(e) => {
            setTypePayload({
              ...typePayload,
              oneTimeFee: e.target.value
            })
          }}
        />
      )
    }

  }

  const renderRecurringFee = (isEdit = false) => {

    if (isEdit) {

      return (
        <Input
          type="number"
          value={editTypePayload.recurringFee}
          placeholder="0"
          onChange={(e) => {
            setEditTypePayload({
              ...editTypePayload,
              recurringFee: e.target.value
            })
          }}
        />
      )

    } else {
      return (
        <Input
          type="number"
          placeholder="0"
          onChange={(e) => {
            setTypePayload({
              ...typePayload,
              recurringFee: e.target.value
            })
          }}
        />
      )
    }

  }

  const createType = () => {

    if (typePayload.name.length <= 0) {
      return NotificationManager.error("Name missing");
    }

    if (typePayload.label.length <= 0) {
      return NotificationManager.error("Label missing");
    }

    if (typePayload.discordRoleID.length <= 0) {
      return NotificationManager.error("Discord Role missing");
    }

    setIsLoading(true);

    axios({
      method: 'post',
      url: '/api/admin/licenses/create-type',
      data: typePayload,
    }).then(res => {
      setIsLoading(false);
      setLicenseTypes(res.data.licenseTypes);
      hideModal();
    });

  }

  const updateType = () => {

    if (editTypePayload.name.length <= 0) {
      return NotificationManager.error("Name missing");
    }

    if (editTypePayload.label.length <= 0) {
      return NotificationManager.error("Label missing");
    }

    if (editTypePayload.discordRoleID.length <= 0) {
      return NotificationManager.error("Discord Role missing");
    }

    setIsLoading(true);

    axios({
      method: 'put',
      url: '/api/admin/licenses/update-type',
      data: editTypePayload,
    }).then(res => {
      setLicenseTypes(res.data.licenseTypes);
      hideEditModal();
      setIsLoading(false);
    });

  }

  const refreshList = () => {
    setIsLoading(true);

    axios
      .get('/api/admin/licenses/types')
      .then(res => {
        setLicenseTypes(res.data.licenseTypes);
        setDiscordRoles(res.data.discordRoles);
        setTypePayload({
          ...typePayload,
          discordRoleID: res.data.discordRoles.length > 0 ? res.data.discordRoles[0].id : ""
        })
        setStripePrices(res.data.prices);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }

  const searchLicenseType = (value) => {

    if (value.length > 0) {


      axios
        .get('/api/admin/licenses/search-license-types?search=' + value)
        .then(res => {
          setLicenseTypes(res.data.licenseTypes);
        })
        .catch(err => {
          console.error(err);
        });

    } else {
      axios
        .get('/api/admin/licenses/types')
        .then(res => {
          setLicenseTypes(res.data.licenseTypes);
        })
        .catch(err => {
          console.error(err);
        });
    }

  }

  if (isLoading) return (
    <Spinner></Spinner>
  );

  return (
    <>
      <Media query={{ maxWidth: 700 }}>
        {matches => (
          <Header dir={matches && 'column'} h={!matches && '90px'} w="100%" align={!matches && 'center'}>
            <Search placeholder="Search types" onKeyPress={e => e.key == "Enter" ? searchLicenseType(e.target.value) : ""} />
            <Flex fg="1" h="24px" />
            <Flex>
              <Button bg="#0393FF" onClick={revealModal}>Add New Type</Button>
              <Flex w="12px" />
              <Button bg="#F32FE0" onClick={refreshList}>Refresh List</Button>
            </Flex>
          </Header>
        )}
      </Media>
      <Content w="100%" minw="900px" dir="column">
        <HeaderRow w='100%' minw="840px">
          <Flex w="5%">Name</Flex>
          <Flex w="5%">Label</Flex>
          <Flex w="10%">Role ID</Flex>
          <Flex w="10%">One Time Fee</Flex>
          <Flex w="10%">Recurring Fee</Flex>
          <Flex w="10%">Trial ( Days )</Flex>
          <Flex w="10%">Unbindable</Flex>
          <Flex w="10%">Unbind Delay ( Days )</Flex>
          <Flex w="10%">Max Instances</Flex>
          <Flex w="5%">Renewal Length</Flex>
        </HeaderRow>
        {licenseTypes.map((value) => {
          return <Type revealEditModal={revealEditModal} data={value} />
        })}
      </Content>

      <NotificationContainer />

      {showModal &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">Create Type</Text.Heading>
            <Flex h="24px" />
            <Label>Name</Label>
            <Flex h="16px" />
            <Flex dir="row" w="100%">
              <Input
                type="text"
                placeholder="Name"
                onChange={(e) => {
                  setTypePayload({
                    ...typePayload,
                    name: e.target.value
                  })
                }}
              />
              <Flex w="16px" />
              <Input
                type="text"
                placeholder="Label"
                onChange={(e) => {
                  setTypePayload({
                    ...typePayload,
                    label: e.target.value
                  })
                }}
              />
            </Flex>
            <Flex h="24px" />
            <Label>Discord Role ID</Label>
            <Flex h="16px" />
            {renderDiscordRoles()}
            <Flex h="24px" />
            <Label>Fee(s)</Label>
            <Flex h="16px" />
            <Flex dir="row" w="100%">
              {renderOneTimeFee()}
              <Flex w="16px" />
              {renderRecurringFee()}
            </Flex>
            <Flex h="24px" />
            <Label>Trial Days Amount</Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              onChange={(e) => {
                setTypePayload({
                  ...typePayload,
                  trialDays: parseInt(e.target.value)
                })
              }}
            />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Toggle
                active={typePayload.unbindable == 1}
                onClick={() => {
                  setTypePayload({
                    ...typePayload,
                    unbindable: 1
                  })
                }}
              >Unbindable</Toggle>
              <Flex w="16px" />
              <Toggle
                active={typePayload.unbindable == 0}
                onClick={() => {
                  setTypePayload({
                    ...typePayload,
                    unbindable: 0
                  })
                }}
              >Not Unbindable</Toggle>
            </Flex>
            <Flex h="24px" />
            <Label>Unbind Delay (Days)</Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              onChange={(e) => {
                setTypePayload({
                  ...typePayload,
                  unbindDelay: parseInt(e.target.value)
                })
              }}
            />
            <Flex h="24px" />
            <Label>Max Instances</Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              onChange={(e) => {
                setTypePayload({
                  ...typePayload,
                  maxInstances: parseInt(e.target.value)
                })
              }}
            />
            <Flex h="24px" />
            <Label>Renewal Length ( days )</Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              onChange={(e) => {
                setTypePayload({
                  ...typePayload,
                  renewalLength: parseInt(e.target.value)
                })
              }}
            />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={hideModal} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={createType}>Create Type</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }

      {showEditModal &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">Update Type</Text.Heading>
            <Flex h="24px" />
            <Label>Name</Label>
            <Flex h="16px" />
            <Flex dir="row" w="100%">
              <Input
                type="text"
                placeholder="Name"
                value={editTypePayload.name}
                onChange={(e) => {
                  setEditTypePayload({
                    ...editTypePayload,
                    name: e.target.value
                  })
                }}
              />
              <Flex w="16px" />
              <Input
                type="text"
                placeholder="Label"
                value={editTypePayload.label}
                onChange={(e) => {
                  setEditTypePayload({
                    ...editTypePayload,
                    label: e.target.value
                  })
                }}
              />
            </Flex>
            <Flex h="24px" />
            <Label>Discord Role ID</Label>
            <Flex h="16px" />
            {renderDiscordRoles(true)}
            <Flex h="24px" />
            <Label>Price(s)</Label>
            <Flex h="16px" />
            <Flex dir="row" w="100%">
              {renderOneTimeFee(true)}
              <Flex w="16px" />
              {renderRecurringFee(true)}
            </Flex>
            <Flex h="24px" />
            <Label>Trial Days Amount</Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              value={editTypePayload.trialDays}
              onChange={(e) => {
                setEditTypePayload({
                  ...editTypePayload,
                  trialDays: parseInt(e.target.value)
                })
              }}
            />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Toggle
                active={editTypePayload.unbindable == 1}
                onClick={() => {
                  setEditTypePayload({
                    ...editTypePayload,
                    unbindable: 1
                  })
                }}
              >Unbindable</Toggle>
              <Flex w="16px" />
              <Toggle
                active={editTypePayload.unbindable == 0}
                onClick={() => {
                  setEditTypePayload({
                    ...editTypePayload,
                    unbindable: 0
                  })
                }}
              >Not Unbindable</Toggle>
            </Flex>
            <Flex h="24px" />
            <Label>Unbind Delay (Days)</Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              value={editTypePayload.unbindDelay}
              onChange={(e) => {
                setEditTypePayload({
                  ...editTypePayload,
                  unbindDelay: parseInt(e.target.value)
                })
              }}
            />
            <Flex h="24px" />
            <Label>Max Instances</Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              value={editTypePayload.maxInstances}
              onChange={(e) => {
                setEditTypePayload({
                  ...editTypePayload,
                  maxInstances: parseInt(e.target.value)
                })
              }}
            />
             <Flex h="24px" />
            <Label>Renewal Length ( days ) </Label>
            <Flex h="16px" />
            <Input
              type="number"
              min="0"
              placeholder="0"
              value={editTypePayload.renewalLength}
              onChange={(e) => {
                setEditTypePayload({
                  ...editTypePayload,
                  renewalLength: parseInt(e.target.value)
                })
              }}
            />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={hideEditModal} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={updateType}>Update Type</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }
    </>
  )
}

export default Types;
